import {
  type CollectionTimeOfDay,
  type CollectionWindow,
  getCollectionProviderDisplayName,
  getCollectionWindow,
  isCollectionCarrier,
} from "@redotech/redo-return-core-common/collection/collection-provider";

export function getCollectionProviderName(provider: string): string {
  return isCollectionCarrier(provider)
    ? getCollectionProviderDisplayName(provider)
    : provider;
}

export function getProviderCollectionWindow(
  provider: string,
): CollectionWindow | undefined {
  return isCollectionCarrier(provider)
    ? getCollectionWindow(provider)
    : undefined;
}

/** Collection dates are in the provider's local (UK) calendar, so they read as UK dates. */
export function formatCollectionDate(date: string, language: string): string {
  return Temporal.PlainDate.from(date).toLocaleString(
    new Intl.Locale(language, { region: "GB" }).toString(),
    { weekday: "long", day: "numeric", month: "long" },
  );
}

export function formatCollectionTime(
  time: CollectionTimeOfDay,
  language: string,
): string {
  return Temporal.PlainTime.from(time).toLocaleString(language, {
    hour: "numeric",
    minute: time.minute === 0 ? undefined : "2-digit",
  });
}
